<template>
  <nav class="sidebar-menu col-3">
    <div class="fixed-area">
      <div class="btns-area">
        <router-link
          v-show="!isRetailMember"
          :to="{ name: '購買方案' }"
          class="transparent-btn"
        >
          購買方案
        </router-link>
        <router-link :to="{ name: '購買商品' }" class="transparent-btn">
          購買商品
        </router-link>
        <router-link :to="{ name: '歷史購買紀錄' }" class="transparent-btn">
          歷史購買紀錄
        </router-link>
      </div>
      <div class="purchase-details">
        <h4 class="purchase-details__title">
          購買明細
        </h4>

        <div class="purchase-details__list">
          <div v-show="!isShowList" class="no-product">
            目前沒有商品
          </div>
          <div v-show="isShowList" class="calculate-area">
            <SingleProgram
              v-for="(program, index) in programs"
              :key="`program_${index}`"
              :index="index"
              :program="program"
              :level="level"
            />
            <SingleProduct
              v-for="(product, index) in products"
              :key="'product_' + index"
              :id="'product_' + index"
              :index="index"
              :product="product"
            />
            <div class="original-price">
              <div class="original-price__title">原價</div>
              <div class="original-price__price">$ {{ total }}</div>
            </div>

            <div class="discount">
              <div class="discount__title">
                折扣
              </div>
              <div class="discount__price">- $ {{ discount }}</div>
            </div>

            <div class="subtotal">
              <div class="subtotal__title">
                小計
              </div>
              <div class="subtotal__price">$ {{ subtotal }}</div>
            </div>

            <div class="discount">
              <div class="discount__title">
                {{ eventDiscountTitle }}
              </div>
              <div class="discount__price">- $ {{ eventDiscountPrice }}</div>
            </div>

            <div class="subtotal">
              <div class="subtotal__title">
                應收金額
              </div>
              <div class="subtotal__price">$ {{ receivableAmount }}</div>
            </div>
          </div>
          <button
            v-show="isShowList"
            class="custom-btn checkout-btn"
            @click="confirmOrder"
          >
            確認結帳
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import SingleProduct from '@/components/Layouts/SidebarMenu/SingleProduct';
import SingleProgram from '@/components/Layouts/SidebarMenu/SingleProgram';
import { mapState, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  components: {
    SingleProduct,
    SingleProgram
  },
  data() {
    return {};
  },
  props: {
    level: {
      type: Object,
      default() {
        return {
          name: '一般',
          discount_percentage: 1
        };
      }
    },
    memberId: null
  },
  computed: {
    ...mapState('order', { eventDiscount: state => state.discount }),
    ...mapGetters('order', ['order', 'products', 'programs']),
    isShowList() {
      return this.programs.length != 0 || this.products.length != 0;
    },
    total() {
      return _.get(this.order, 'total', 0);
    },
    /**
     * 小計=金額-商品折扣金額.
     */
    subtotal() {
      return this.total - this.discount;
    },
    /**
     * 活動折扣金額.
     */
    eventDiscountPrice() {
      return _.get(this.eventDiscount, 'price', 0);
    },
    /**
     * 活動折扣標題.
     */
    eventDiscountTitle() {
      return _.get(this.eventDiscount, 'title', '活動折扣金額');
    },
    /**
     * 應收金額.
     */
    receivableAmount() {
      return this.subtotal - this.eventDiscountPrice;
    },
    discount() {
      if (this.order == null) {
        return 0;
      }
      return (
        this.order.course_discount +
        this.order.level_discount_amount +
        this.order.product_discount_percent +
        this.order.product_discount_price +
        this.order.program_discount_percent +
        this.order.program_discount_price +
        this.order.giveaway_discount_price +
        this.order.combination_discount_amount +
        this.order.subtotal_discount_amount +
        this.order.coupon_discount_amount
      );
    },
    isRetailMember() {
      return this.memberId == 1;
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.onScroll);
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      var oBox = document.querySelector('.fixed-area');
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop; //body 是 For Safari

      // this.startMove(scrollTop);

      //clientHeight 視窗高度

      // oBox.offsetHeight oBox的高度

      oBox.style.top = scrollTop + 'px';
    },
    confirmOrder() {
      this.$router.push({
        name: '結帳明細'
      });
    }

    // startMove(iTarget) {
    //   var timer = null;
    //   var oBox = document.querySelector('.fixed-area');
    //   clearInterval(timer);

    //   timer = setInterval(function() {
    //     console.log('in interval' + iTarget);
    //     // var speed = (iTarget - oBox.offsetTop) / 8;
    //     // if (speed > 0) {
    //     //   Math.ceil(speed);
    //     // } else {
    //     //   Math.floor(speed);
    //     // }

    //     // if (oBox.offsetTop == iTarget) {
    //     //   clearInterval(timer);
    //     // } else {
    //     //   oBox.style.top = oBox.offsetTop + speed + 'px';
    //     // }
    //   }, 30);
    // }
  }
};
</script>
